import React from 'react'

import _modules from '../../_modules'

const GeneralLedgersDetail = React.lazy(() => import('./views/generalLedgers/GeneralLedgersDetail'))
const GeneralLedgers = React.lazy(() => import('./views/generalLedgers/GeneralLedgers'))
const LedgersDetail = React.lazy(() => import('./views/ledgers/LedgersDetail'))
const Ledgers = React.lazy(() => import('./views/ledgers/Ledgers'))
const VouchersDetail = React.lazy(() => import('./views/vouchers/VouchersDetail'))
const Vouchers = React.lazy(() => import('./views/vouchers/Vouchers'))
const VoucherTypesDetail = React.lazy(() => import('./views/voucherTypes/VoucherTypesDetail'))
const VoucherTypes = React.lazy(() => import('./views/voucherTypes/VoucherTypes'))
const BanksDetail = React.lazy(() => import('../account/views/banks/BanksDetail'))
const Banks = React.lazy(() => import('../account/views/banks/Banks'))
const BankTransactionsDetail = React.lazy(() =>
  import('../account/views/bankTransactions/BankTransactionsDetail'),
)
const BankTransactions = React.lazy(() =>
  import('../account/views/bankTransactions/BankTransactions'),
)
const CreditCardsDetail = React.lazy(() => import('../account/views/creditCards/CreditCardsDetail'))
const CreditCards = React.lazy(() => import('../account/views/creditCards/CreditCards'))
const CreditCardTransactionsDetail = React.lazy(() =>
  import('../account/views/creditCardTransactions/CreditCardTransactionsDetail'),
)
const CreditCardTransactions = React.lazy(() =>
  import('../account/views/creditCardTransactions/CreditCardTransactions'),
)
const DebitCardsDetail = React.lazy(() => import('../account/views/debitCards/DebitCardsDetail'))
const DebitCards = React.lazy(() => import('../account/views/debitCards/DebitCards'))
const DebitCardTransactionsDetail = React.lazy(() =>
  import('../account/views/debitCardTransactions/DebitCardTransactionsDetail'),
)
const DebitCardTransactions = React.lazy(() =>
  import('../account/views/debitCardTransactions/DebitCardTransactions'),
)

/*const TaxesDetail = React.lazy(() => import('../account/views/taxes/TaxesDetail'))
const Taxes = React.lazy(() => import('../account/views/taxes/Taxes'))*/

const AccountSettingsDetail = React.lazy(() =>
  import('./views/accountSettings/AccountSettingsDetail'),
)

const _routes = []

if (_modules.ledgers) {
  _routes.push(
    ...[
      {
        path: '/general-ledgers/:id',
        name: 'General Ledger Detail',
        component: GeneralLedgersDetail,
      },
      { path: '/general-ledgers', name: 'General Ledgers', component: GeneralLedgers },
    ],
  )
  _routes.push(
    ...[
      {
        path: '/ledgers/:id',
        name: 'Ledger Detail',
        component: LedgersDetail,
      },
      { path: '/ledgers', name: 'Ledgers', component: Ledgers },
    ],
  )
}
if (_modules.vouchers) {
  _routes.push(
    ...[
      {
        path: '/vouchers/:id',
        name: 'Voucher Detail',
        component: VouchersDetail,
      },
      { path: '/vouchers', name: 'Vouchers', component: Vouchers },
    ],
  )
  _routes.push(
    ...[
      {
        path: '/voucher-types/:id',
        name: 'Voucher Type Detail',
        component: VoucherTypesDetail,
      },
      { path: '/voucher-types', name: 'Voucher Types', component: VoucherTypes },
    ],
  )
}

if (_modules.banks) {
  _routes.push(
    ...[
      {
        path: '/banks/:id',
        name: 'Bank Detail',
        component: BanksDetail,
      },
      { path: '/banks', name: 'Banks', component: Banks },
    ],
  )
  _routes.push(
    ...[
      {
        path: '/bank-transactions/:id',
        name: 'Bank Transaction Detail',
        component: BankTransactionsDetail,
      },
      { path: '/bank-transactions', name: 'Bank Transactions', component: BankTransactions },
    ],
  )
}

if (_modules.credit_cards) {
  _routes.push(
    ...[
      {
        path: '/credit-cards/:id',
        name: 'Credit Card Detail',
        component: CreditCardsDetail,
      },
      { path: '/credit-cards', name: 'Credit Cards', component: CreditCards },
    ],
  )
  _routes.push(
    ...[
      {
        path: '/credit-card-transactions/:id',
        name: 'Credit Card Transaction Detail',
        component: CreditCardTransactionsDetail,
      },
      {
        path: '/credit-card-transactions',
        name: 'Credit Card Transactions',
        component: CreditCardTransactions,
      },
    ],
  )
}
if (_modules.debit_cards) {
  _routes.push(
    ...[
      {
        path: '/debit-cards/:id',
        name: 'Debit Card Detail',
        component: DebitCardsDetail,
      },
      { path: '/debit-cards', name: 'Debit Cards', component: DebitCards },
    ],
  )
  _routes.push(
    ...[
      {
        path: '/debit-card-transactions/:id',
        name: 'Debit Card Transaction Detail',
        component: DebitCardTransactionsDetail,
      },
      {
        path: '/debit-card-transactions',
        name: 'Debit Card Transactions',
        component: DebitCardTransactions,
      },
    ],
  )
}

/*if (_modules.taxes)
  _routes.push(
    ...[
      {
        path: '/taxes/:id',
        name: 'Tax Detail',
        component: TaxesDetail,
      },
      { path: '/taxes', name: 'Taxes', component: Taxes },
    ],
  )*/

if (_modules.account_settings)
  _routes.push(
    ...[
      {
        path: '/account-settings',
        name: 'Account Setting',
        component: AccountSettingsDetail,
      },
    ],
  )

export default _routes
